import { Button, Input, Modal } from "antd";
import React from "react";

export default function ModalRejectDisbursement({
  submitting,
  visible,
  onReject,
  onClose,
  errorReject,
  setReasonReject,
  name,
  reasonReject,
}) {
  return (
    <Modal
      zIndex={10000}
      title={"Yakin Ingin Membatalkan Komisi?"}
      visible={visible}
      onCancel={onClose}
      width={500}
      centered
      footer={[
        <Button
          disabled={submitting}
          key="back"
          onClick={onClose}
          className="btn-modal btn-default"
          style={{ width: 100 }}
        >
          Kembali
        </Button>,
        <Button
          disabled={submitting}
          key="submit"
          type="danger"
          onClick={onReject}
          className="btn-modal"
          style={{ width: 100 }}
        >
          Batalkan
        </Button>,
      ]}
    >
      <div className="my-2">
        Anda akan membatalkan komisi untuk{" "}
        <span style={{ fontWeight: "600" }}>{name}</span>. Berikan alasan
        pembatalan sebelum melanjutkan.
      </div>
      <div className="mt-2 d-flex">
        <div className="color-A6A6A6" style={{ flex: 1 }}>
          Alasan :
        </div>
        <div style={{ flex: 3 }}>
          <Input.TextArea
            required
            type="text"
            className="border-DCDCDC text-input"
            onChange={(e) => setReasonReject(e.target.value)}
            rows={4}
            value={reasonReject}
          />
          {errorReject ? (
            <span className="small text-danger">Alasan harus diisi</span>
          ) : null}
        </div>
      </div>
    </Modal>
  );
}
